import { combineReducers } from 'redux'
import { Epic } from 'redux-observable'
import { createAsyncAction, createReducer, isActionOf } from 'typesafe-actions'
import { RootActions } from '../../root'
import { filter, map, mergeMap } from 'rxjs/operators'
import { apiRequests } from '../../../http/config'
import { PermissionGroup } from '../../../responses/users'
import { payloadReducer } from '../../../utils/redux-utils'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'

const actions = {
    list: createAsyncAction(
        '@PERMISSIONS/LIST_REQUEST',
        '@PERMISSIONS/LIST_SUCCESS',
        '@PERMISSIONS/LIST_FAILURE',
    )<undefined, PermissionGroup[], void>(),
}

export { actions as permissionsActions }

export interface PermissionsState {
    data: PermissionGroup[],
}

export const permissionsReducer = combineReducers<PermissionsState>({
    data: createReducer<PermissionGroup[]>([])
        .handleAction(actions.list.success, payloadReducer),
})

const list: Epic<RootActions> = action$ => action$.pipe(
    filter(isActionOf(actions.list.request)),
    mergeMap(() => apiRequests.permission.listByGroup({})),
    map(({ response }) => response.success ?
        actions.list.success(response.rows) :
        actions.list.failure(toastFailedResponse(response, 'Не удалось получить доступы'))
    ),
)

export const permissionsEpic = list